"use strict";

module.exports = function getServiceSet(setType, entityName, user, entity, allItems) {
	
	// megnézzük, benne van-e services-ben
	for (var serviceSet of user.services) {
		if (serviceSet.type == setType && serviceSet.value[entityName] == entity._id)
			return serviceSet;
	}
	
	// ha nincs, keressük meg a groupját és vizsgáljunk arra
	
	if (entity.groups.length == 0)
		return null;
	
	for (var item of allItems) {
		if (entity.groups.indexOf(item._id) > -1) {
			var groupServiceSet = getServiceSet(setType, entityName, user, item, allItems);
			if (groupServiceSet)
				return groupServiceSet;
		}
	}
	
	return null;
};


// WEBPACK FOOTER //
// ./~/vfu/getServiceSet.js